<template>
    <div class="block w-full z-0">
        <form @submit="onsubmit" id="prev">
            <input type="hidden" name="Prev" :value="JSON.stringify(prev)">
        </form>
        <div class="flex w-full" :style="'margin-bottom: ' + bottomHeight + 'px;'">
            <div :class="'w-' + cmsLeft.Column">
                <cms :data="cmsLeft.Data" />
            </div>
            <div :class="'w-' + cmsRight.Column" v-if="cmsRight">
                <cms :data="cmsRight.Data" />
            </div>
        </div>
        <div id="bottom-fixed" class="fixed w-full bottom-0 left-0 bg-white p-2" style="z-index: 10;" v-if="config && config.StickyBook">
            <div class="container flex justify-between">
                <span class="my-auto">{{ config.Name }}</span>
                <div class="flex">
                    <b-button type="is-dark" style="width: 200px;">Book Now</b-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    computed: {
        data () {
            return this.$store.state.service.company
        }
    },
    components: {
        cms: () => import('@/components/cms')
    },
    data () {
        return {
            checkbox: false,
            cmsLeft: [],
            cmsRight: [],
            config: {},
            prev: []
        }
    },
    watch: {
        async '$route' (to, from) {
            this.init()
        }
    },
    methods: {
        async init () {
            try {
                var response = await this.$baseApi.get(this.$route.fullPath)
                await this.getConfigInit(response)
                if (window.location.host !== 'ilog.id' && window.location.host !== 'elite.ezbooking.co' && window.location.host !== 'book.ezbooking.co' && window.location.host !== 'localhost:8084') {
                    if (!response.Left) return false
                    if (!response.Right) return false
                    if (!response.Config) return false
                }
                this.cmsLeft = response.Left
                this.cmsRight = response.Right
                this.config = response.Config
                if (response.Config.Sidebar) this.$sidebar.value = response.Config.Sidebar
                this.$headerActive.value = this.config.HeaderActive !== 'undefined' ? this.config.HeaderActive : true
                var config = JSON.parse(localStorage.getItem('config'))
                document.title = config && config.Title ? config.Title : 'Page'
                setTimeout(() => {
                    var bottom = document.getElementById('bottom-fixed') || document.getElementById('mobile-footer')
                    this.$store.commit('service/SET_BOTTOM_HEIGHT', bottom ? bottom.clientHeight : 0)
                }, 200)
            } catch (err) {
                console.log('err', err)
            }
        },
        getConfigInit (data) {
            var res
            if (!data.Config && window.location.host !== 'ilog.id') return false
            else if (!data.Config.Init && (window.location.host === 'ilog.id' || window.location.host === 'elite.ezbooking.co' || window.location.host === 'book.ezbooking.co' || window.location.host === 'localhost:8084')) return false
            return new Promise((resolve) => {
                data.Config.Init.forEach(async (item) => {
                    res = await this.$baseApi.get(this.stringReader(item))
                    this.prev.push(res)
                })
                resolve(this.sleep(700))
            })
        }
    },
    // mounted () {
    //     this.init()
    // },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.init()
            next()
        })
    }
}
</script>
